import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const template = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '合同名称',
            dataIndex: 'contractName',
            key: 'contractName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contractName'
            },
            filteredValue: filteredInfo.contractName || [],
        },
        {
            title: '合同类型',
            dataIndex: 'contractType',
            key: 'contractType',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.contractType || [],
        },
        {
            title: '项目分类',
            dataIndex: 'projectClassification',
            key: 'projectClassification',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.projectClassification || [],
        },
        {
            title: '项目子分类',
            dataIndex: 'projectSubcategories',
            key: 'projectSubcategories',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.projectSubcategories || [],
        },
        // {
        //     title: '项目类型',
        //     dataIndex: 'projectType',
        //     key: 'projectType',
        //     scopedSlots: {
        //         filterDropdown: 'filterDropdown',
        //         filterIcon: 'filterIcon',
        //         filtered: true,
        //     },
        //     filteredValue: filteredInfo.projectType || [],
        // },
        {
            title: '合同维护人员',
            dataIndex: 'contractMaintainer',
            key: 'contractMaintainer',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.contractMaintainer || [],
        },
        {
            title: '文件大小',
            dataIndex: 'size',
            key: 'size'
        },
        {
            title: '文件更新时间',
            dataIndex: 'updateTime',
            key: 'updateTime'
        },
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 150
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || []
        }
    ]
}
